export default "__VITE_ASSET__Cd66EbxZ__"